import { generatePaginationPageNumbers } from '@/utils/global';

const Pagination = ({ currentPage, pageCount, onPageChange, t, device }) => {
  if (pageCount <= 1) return null;

  const handlePageClick = (page) => {
    if (page >= 1 && page <= pageCount) {
      onPageChange(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const pageNumbers = generatePaginationPageNumbers(
    currentPage,
    pageCount,
    device === 'mobile' ? 3 : 6
  );

  return (
    <div className='my-4 mt-7 flex items-center justify-center gap-2 text-sm text-gray-700 md:text-lg'>
      {/* Previous Button */}
      <button
        className='hover:bg-primary-800 bg-primary h-8.75 w-21.5 rounded-lg text-sm font-bold text-white transition-all duration-200 disabled:cursor-not-allowed disabled:bg-[#D9D9D9] disabled:font-normal disabled:text-black'
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label='Previous page'
      >
        {t('Prev')}
      </button>

      {/* Page Numbers */}
      {pageNumbers.map((page, index) =>
        page === '...' ? (
          <span key={index} className='text-primary-500 p-1'>
            ...
          </span>
        ) : (
          <button
            key={index}
            className={`h-8.75 w-8.25 rounded-lg text-sm font-bold transition-all duration-200 ${
              currentPage === page
                ? 'bg-primary font-semibold text-white shadow-md'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
            onClick={() => handlePageClick(page)}
            aria-label={`Go to page ${page}`}
          >
            {page}
          </button>
        )
      )}

      {/* Next Button */}
      <button
        className='bg-primary hover:bg-primary-800 h-8.75 w-18.5 rounded-[10px] text-sm font-bold text-white transition-all duration-200 disabled:cursor-not-allowed disabled:bg-[#D9D9D9] disabled:font-normal disabled:text-black'
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage === pageCount}
        aria-label='Next page'
      >
        {t('Next')}
      </button>
    </div>
  );
};

export default Pagination;
